import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import TvIcon from "@material-ui/icons/Tv";
import { useQuery } from "@tanstack/react-query";
import { fetchFilasHome } from "../../../../shared/fetchers/filasHome";
import { fetchLibros } from "../../../../shared/fetchers/libros";
import ListaFilas from "./lista-filas";
import CrearFila from "./crear-fila";
import GestionarLibros from "./gestionar-libros";

const VIEW_LIST = "list";
const VIEW_CREATE = "create";
const VIEW_EDIT = "edit";
const VIEW_BOOKS = "books";

const FilasHome = () => {
  const [view, setView] = useState(VIEW_LIST);
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);

  const {
    data: filasHome = [],
    isLoading: loadingFilas,
    isError,
  } = useQuery(["filasHome"], fetchFilasHome);

  const {
    data: libros,
    isLoading: loadingLibros,
    isError: errorLibros,
  } = useQuery(["libros"], fetchLibros);

  const goList = () => {
    setFilaSeleccionada(null);
    setView(VIEW_LIST);
  };

  const handleCrear = () => {
    setFilaSeleccionada(null);
    setView(VIEW_CREATE);
  };

  const handleEditar = (fila) => {
    setFilaSeleccionada(fila);
    setView(VIEW_EDIT);
  };

  const handleGestionarLibros = (fila) => {
    setFilaSeleccionada(fila);
    setView(VIEW_BOOKS);
  };

  if (isError) {
    return (
      <div className="admin-page-tilte">
        Error cargando las filas. Inténtalo nuevamente.
      </div>
    );
  }

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <TvIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Filas Home</div>
      </div>

      <Container fluid>
        <Row>
          {view === VIEW_LIST && (
            <ListaFilas
              filasHome={filasHome}
              loading={loadingFilas}
              onCrear={handleCrear}
              onEditar={handleEditar}
              onGestionarLibros={handleGestionarLibros}
            />
          )}

          {(view === VIEW_CREATE || view === VIEW_EDIT) && (
            <CrearFila
              fila={view === VIEW_EDIT ? filaSeleccionada : null}
              onVolver={goList}
              onSaved={goList}
            />
          )}

          {view === VIEW_BOOKS && filaSeleccionada && (
            <>
              {loadingLibros || errorLibros ? (
                <div className="admin-muted-text-small p-4">
                  {errorLibros
                    ? "Error cargando libros."
                    : "Cargando catálogo de libros…"}
                </div>
              ) : (
                <GestionarLibros
                  fila={filaSeleccionada}
                  libros={libros}
                  onVolver={goList}
                />
              )}
            </>
          )}
        </Row>
      </Container>
    </>
  );
};

export default FilasHome;
